<template>
  <div>
    <!--库存信息-->
    <div class="section" style="flex: 1;">
      <span class="title">{{ $t('CargoMsg.Cargo_InventoryInfo') }}</span>
      <div class="operations" style="padding-bottom: 10px">
        <div v-show="cooperateEdit" class="triggers">
          <el-button v-if="!fbaLob && $checkPermission(['button_FBAOverseaWarehousing_dischargeByPallet'])" type="primary" :disabled="isEditing || isNoInWarehouse" @click="byPalletHandler">
            {{ $t('CargoMsg.Cargo_OutboundByPallet') }}
          </el-button>
          <el-button v-if="!fbaLob && $checkPermission(['button_FBAOverseaWarehousing_outInCartons'])" type="primary" :disabled="isEditing || isNoInWarehouse" @click="byBoxHandler">
            {{ $t('CargoMsg.Cargo_OutboundByBox') }}
          </el-button>
        </div>
      </div>
      <cargo-ag-grid
        config-module="9300011"
        :grid-options="up.goodGridOptions"
        :column-defs="up.goodsColumn"
        :row-data="upRowData || []"
        style="flex-grow:1;margin-top:5px"
        @gridReady="params=>{up.gridApi=params.api}"
      />
    </div>
    <div class="section" style="float:left; padding-top: 10px;">
      <el-form :inline="true" label-width="65px" label-position="left" :disabled="true">
        <el-form-item :label="$t('CargoMsg.Cargo_PalletQuantity')+':'" class="custom" />
        <el-form-item :label="$t('CargoMsg.Cargo_Outbound')" class="custom">
          <el-input v-model="outWarehouseCount" no="18" style="width:100px" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_NotOutbound')" class="custom">
          <el-input v-model="noOutWarehouseCount" no="19" style="width:100px" />
        </el-form-item>
      </el-form>
    </div>
    <!--出库批次-->
    <div class="section" style="min-width:1000px; flex: 1;">
      <span class="title">{{ $t('CargoMsg.Cargo_OutboundBatch') }}</span>
      <div v-if="!fbaLob" class="operations">
        <div v-show="cooperateEdit" class="triggers">
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_modifyWarehouseTime'])" type="primary" :disabled="isEditing" @click="kltzHandler">库龄调整</el-button>
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_modifyTheDeliveryTime'])" type="primary" :disabled="isEditing" @click="xgckbzHandler">修改出库备注</el-button>
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_modifyServiceTime'])" type="primary" :disabled="isEditing" @click="toUpdServiceDate">修改送达日期</el-button>
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_withdrawalOfOutbound'])" type="danger" :disabled="isEditing" @click="cxckHandler">撤销出库</el-button>
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_Log'])" type="primary" :disabled="isEditing" @click="logHandler">日志</el-button>
        </div>
      </div>
      <cargo-ag-grid
        config-module="9300012"
        :grid-options="down.goodGridOptions"
        :column-defs="down.goodsColumn"
        :row-data="form.fbaOutWarehouses || []"
        style="flex-grow:1;margin-top:5px"
        @gridReady="params=>{down.gridApi=params.api}"
      />
    </div>

    <!-- 选择托盘 -->
    <el-dialog
      v-if="byPallet.visible"
      v-el-drag-dialog
      :visible.sync="byPallet.visible"
      :title="'按托盘出库'"
      width="1200px"
      :close-on-click-modal="false"
    >
      <cargo-left-right-resize
        :left-style="{display: 'flex', flexDirection: 'column',width:'40%'}"
        :right-style="{display: 'flex', flexDirection: 'column',width:'60%'}"
        style="height: 100%;min-height: 300px"
      >
        <template
          slot="left"
        >
          <div class="section" style="flex: 1">
            <div style="padding-bottom: 8px;">
              <span class="title">托盘</span>
            </div>
            <div style="padding-bottom: 8px;">
              <el-button no="1" type="primary" style="margin-right: 8px;" @click="searchPallet()">查询</el-button>
              <el-input
                v-model="byPallet.left.cargoName"
                no="20"
                style="width:200px;"
                placeholder="根据中文品名过滤托盘"
              />
            </div>
            <cargo-ag-grid
              no="21"
              :show-side-bar="false"
              config-module="140003"
              :grid-options="byPallet.left.gridOptions"
              :grid-params.sync="byPallet.left.gridParams"
              :column-defs="byPallet.left.downLeftColumnDefs"
              :row-data="byPallet.left.downLeftRowData"
              style="height:100%"
              @gridReady="params=>byPallet.left.gridApi=params.api"
            />
          </div>
        </template>
        <template
          slot="right"
        >
          <div class="section" style="flex: 1;">
            <div style="padding-bottom: 8px;">
              <span class="title">货物明细</span>
            </div>
            <cargo-ag-grid
              no="25"
              :show-side-bar="false"
              config-module="140004"
              :grid-options="byPallet.right.gridOptions"
              :grid-params.sync="byPallet.right.gridParams"
              :column-defs="byPallet.right.downRightColumnDefs"
              :row-data="byPallet.right.downRightRowData || []"
              style="flex-grow:1"
              @gridReady="params=>byPallet.right.gridApi=params.api"
            />
          </div>
        </template>
      </cargo-left-right-resize>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="chooseByPallet">选中</el-button>
        <el-button @click="byPallet.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 出库 -->
    <el-dialog
      v-if="exWarehouse.visible"
      v-el-drag-dialog
      :visible.sync="exWarehouse.visible"
      :title="$t('Warehouse.ExWarehouse')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" label-position="left">
        <el-form-item v-if="exWarehouse.opType === 'box'" :label="'货箱数量'">
          <el-input v-model="exWarehouse.boxesNumber" :disabled="true" no="refContainerNo" style="width:100%" />
        </el-form-item>
        <el-form-item v-if="exWarehouse.opType === 'pallet'" :label="'托盘数量'">
          <el-input v-model="exWarehouse.palletNumber" :disabled="true" no="refContainerNo" style="width:100%" />
        </el-form-item>
        <el-form-item :label="'出库模式'">
          <el-select
            v-model="exWarehouse.deliveryMode"
            :disabled="exWarehouse.opType !== 'box'"
            no="deliveryMode"
            style="width:100%"
            placeholder=" "
          >
            <el-option label="按托盘出库" :value="1" />
            <el-option label="按箱出库" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="exWarehouse.deliveryMode === 1 && exWarehouse.opType === 'box'">
          <span slot="label" class="blue">{{ '托盘数量' }}</span>
          <el-input v-model="exWarehouse.palletNumber" no="refContainerNo" style="width:100%" />
        </el-form-item>
        <el-form-item>
          <span slot="label" class="blue">{{ $t('Warehouse.DeliveryDate') }}</span>
          <el-date-picker
            v-model="exWarehouse.warehouseOutDate"
            no="warehouseOutDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
            :placeholder="$t('SeaExport.SelectTime')"
          />
        </el-form-item>
        <el-form-item :label="'出库备注'">
          <el-input v-model="exWarehouse.remark" no="remark" style="width:100%" type="textarea" :row="12" />
        </el-form-item>
        <el-form-item :label="'操作人'">
          <cargo-user-select
            no="op"
            :disabled="true"
            :method-params="{}"
            :default-value="exWarehouse.operater||''"
            :merge-load="true"
            style="width:100%"
            @change="p=>{exWarehouse.operater=p.value;}"
          />
        </el-form-item>
        <el-form-item :label="'物流单号(尾程)'">
          <el-input v-model="exWarehouse.logisticsNo" no="refContainerNo" style="width:100%" />
        </el-form-item>
        <el-form-item :label="'预计送达时间'">
          <el-date-picker
            v-model="exWarehouse.preDeliveryTime"
            no="warehouseOutDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
            :placeholder="$t('SeaExport.SelectTime')"
          />
        </el-form-item>
        <el-form-item :label="'送达时间'">
          <el-date-picker
            v-model="exWarehouse.deliveryTime"
            :picker-options="pickerOptionsForDeliveryTime"
            no="warehouseOutDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
            :placeholder="$t('SeaExport.SelectTime')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="exWarehouse.opType === 'box' ? toByBox() : toByPallet()">提交</el-button>
        <el-button @click="exWarehouse.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 选择箱货明细 -->
    <el-dialog
      v-if="byBox.visible"
      v-el-drag-dialog
      :visible.sync="byBox.visible"
      :title="'按箱出库'"
      width="1200px"
      :close-on-click-modal="false"
    >
      <div class="section" style="flex: 1">
        <div style="padding-bottom: 8px;">
          <el-form :inline="true" label-width="80px" label-position="left">
            <el-form-item label-width="0">
              <el-button no="1" type="primary" @click="byBoxSearchNoOut()">查询</el-button>
            </el-form-item>
            <el-form-item label="货箱编号">
              <el-select v-model="byBox.containerNoOpt" no="4" style="width: 60px;" placeholder=" ">
                <el-option label="等于" value="=" />
                <el-option label="不等于" value="!=" />
                <el-option label="包含" value="LIKE" />
              </el-select>
              <el-input v-model="byBox.containerNo" no="5" style="width:150px;padding-left: 8px;" />
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-bottom: 8px;">
          已选中 {{ byBox.selectedCount }} / {{ byBox.rowData.length || 0 }}
          <el-button no="2" @click="byBoxPick()">拣选</el-button>
          <el-input-number
            v-model="byBox.upQuantity"
            no="3"
            controls-position="right"
            :min="0"
            :precision="0"
            style="padding-left: 8px;"
          />
          件
        </div>
        <cargo-ag-grid
          no="10"
          config-module="140005"
          :grid-options="byBox.gridOptions"
          :grid-params.sync="byBox.gridParams"
          :column-defs="byBox.columnDefs"
          :row-data="byBox.rowData"
          style="width:100%;flex:1;min-height: 350px;"
          @gridReady="params=>byBox.gridApi=params.api"
        />
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="chooseByBox">选中</el-button>
        <el-button @click="byBox.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 出库备注/送达日期 -->
    <el-dialog
      v-if="issueRemarks.visible"
      v-el-drag-dialog
      :visible.sync="issueRemarks.visible"
      :title="this.issueRemarks.type"
      width="700px"
      heignt="900px"
      :close-on-click-modal="false"
    >
      <el-input
        v-if="issueRemarks.state === 1"
        v-model="issueRemarks.remark"
        type="textarea"
        style="width:100%"
        placeholder="请输入备注"
        maxlength="300"
        show-word-limit
      />

      <el-date-picker
        v-if="issueRemarks.state === 2"
        v-model="issueRemarks.deliveryTime"
        value-format="yyyy-MM-dd HH:mm"
        no="warehouseOutDate"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        style="width:100%"
      />

      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="submitIssurRemarks">提交</el-button>
        <el-button @click="issueRemarks.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 库龄调整 -->
    <el-dialog
      v-if="storageAgeEdit.visible"
      v-el-drag-dialog
      :visible.sync="storageAgeEdit.visible"
      :title="$t('Warehouse.storageAgeEdit')"
      width="400px"
      class="station-edit-dialog"
      :close-on-click-modal="false"
    >
      <div v-if="storageAgeEdit.visible" class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('Warehouse.storageAgeEditDay')">
            <el-input v-model="storageAgeEdit.storageAgeDayEst" :no="'storageAgeDayEst'" disabled style="width: 50px;margin-right: 8px" />
            <span style="font-family: 'Open Sans', Arial, sans-serif">/</span>
            <el-input v-model="storageAgeEdit.storageAgeDay" :no="'storageAgeDay'" style="width: 50px;margin-left: 8px" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.storageAgeEditWeek')">
            <el-input v-model="storageAgeEdit.storageAgeWeekEst" :no="'storageAgeWeekEst'" disabled style="width: 50px;margin-right: 8px" />
            <span style="font-family: 'Open Sans', Arial, sans-serif">/</span>
            <el-input v-model="storageAgeEdit.storageAgeWeek" :no="'storageAgeWeek'" style="width: 50px;margin-left: 8px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" :no="'save'" @click="storageAgeSaveCallBack">{{ $t('common.btn.save') }}</el-button>
        <el-button :no="'cancel'" @click="storageAgeEdit.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 日志 -->
    <el-dialog
      v-if="batchLog.visible"
      v-el-drag-dialog
      :visible.sync="batchLog.visible"
      :title="$t('CargoMsg.Cargo_Log')"
      width="700px"
      heignt="900px"

      :close-on-click-modal="false"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="batchLog.gridOptions"
        :column-defs="batchLog.columnDefs"
        :row-data="batchLog.rowData"
        style="width:100%;flex:1;min-height: 350px;"
      />
    </el-dialog>
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import CargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { saveToByPallet, saveToByBox, storageAgeAdjustment, rollbackOutWarehouse, updateIssueRemarks, queryOutWarehouseBatchLog } from '@/api/warehouseIn/outWarehouse'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { loadWarehouseInRelated } from '@/api/warehouseIn/warehouseIn'
import { FbaWarehouseInUtil } from '@/class/cargo/model/utils/FbaWarehouseInUtil'
import moment from 'moment'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'FbaOutWarehouse',
  components: {
    CargoUserSelect,
    CargoUpDownResize,
    cargoAdvanceSelect,
    cargoLeftRightResize
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    source: { type: String, required: false },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      SystemConstants,
      WarehouseInState,
      selectTypeNames: TYPE_NAMES,
      URL,
      filter: {},
      gridApi: null,
      form: new WarehouseIn().fillDefaultValue().getData(),
      up: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.up.goodGridOptions.selectedRowIndex = event.rowIndex
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsColumn: [
          /* { headerName: '序号', field: 'sequenceNo', colId: 'sequenceNo', minWidth: 150 },*/
          { headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150 },
          { headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 150 },
          { headerName: this.$t('Warehouse.boxNum'), field: 'allBoxesNumber', colId: 'allBoxesNumber', minWidth: 150 },
          { headerName: this.$t('Warehouse.palletContainerNum'), field: 'dtBoxesNumber', colId: 'dtBoxesNumber', minWidth: 150 },
          { headerName: this.$t('Warehouse.otherContainerNum'), field: 'szBoxesNumber', colId: 'szBoxesNumber', minWidth: 150 },
          { headerName: this.$t('CargoMsg.Cargo_RemainingBoxes'), field: 'syBoxesNumber', colId: 'syBoxesNumber', minWidth: 150 }
        ]
      },
      down: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          selectedRowIndex: -1,
          onCellFocused: event => {
            this.down.goodGridOptions.selectedRowIndex = event.rowIndex
          }
        },
        goodsColumn: [
          {
            headerName: '',
            field: '',
            width: 40,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          { headerName: this.$t('SeaExport.SequenceNumber'), field: 'sequenceNo', colId: 'sequenceNo', minWidth: 150 },
          { headerName: this.$t('CargoMsg.Cargo_BatchNo'), field: 'batchNo', colId: 'batchNo', minWidth: 150 },
          { headerName: this.$t('CargoMsg.Cargo_BoxQuantity'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150 },
          {
            headerName: this.$t('CargoMsg.Cargo_OutboundMode'), field: 'deliveryMode', colId: 'deliveryMode', minWidth: 150,
            valueFormatter: params => {
              return ColumnUtils.deliveryModeLabelFun(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_PalletQuantity'), field: 'palletNumber', colId: 'palletNumber', minWidth: 150 },
          { headerName: this.$t('Warehouse.StorageDay'), field: 'warehouseInDate', colId: 'warehouseInDate', minWidth: 150 },
          { headerName: this.$t('Warehouse.DeliveryDay'), field: 'warehouseOutDate', colId: 'warehouseOutDate', minWidth: 150 },
          { headerName: this.$t('Order.EstimatedDeliveryDate'), field: 'preDeliveryTime', colId: 'preDeliveryTime', minWidth: 150 },
          { headerName: this.$t('Warehouse.DateOfService'), field: 'deliveryTime', colId: 'deliveryTime', minWidth: 150 },
          {
            headerName: this.$t('CargoMsg.Cargo_InventoryAge'), field: 'storageAgeDay', colId: 'storageAgeDay', minWidth: 150,
            valueFormatter: params => {
              const curRow = params.data
              if (!curRow.storageAgeDay && !curRow.storageAgeWeek) return ''
              return curRow.storageAgeDay + this.$t('CargoMsg.Cargo_Days') + '/' + curRow.storageAgeWeek + this.$t('CargoMsg.Cargo_Week')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Status'), field: 'status', colId: 'status', minWidth: 150,
            valueFormatter: params => {
              return ColumnUtils.deliveryStatusLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OutboundOperator'), field: 'operater', colId: 'operater', minWidth: 150,
            valueFormatter: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Modifier'), field: 'modifiedBy', colId: 'modifiedBy', minWidth: 150,
            valueFormatter: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          { headerName: this.$t('Warehouse.LogisticsNo'), field: 'logisticsNo', colId: 'logisticsNo', minWidth: 150 },
          { headerName: this.$t('Warehouse.updateIssueRemarks'), field: 'remark', colId: 'remark', minWidth: 250 }
        ]
      },
      // 按托盘出库
      byPallet: {
        visible: false,
        left: {
          cargoName: '', // 中文名
          gridParams: {},
          gridOptions: {
            rowSelection: 'multiple',
            singleClickEdit: true,
            suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
            suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
            context: {
              componentParent: this
            },
            frameworkComponents: {
              CargoAgGridCommonInputEditor,
              CargoAgGridAdvanceSelectEditor,
              CargoAgGridColumnEditGroup
            },
            onRowClicked: this.palletChangeHandler
          },
          downLeftColumnDefs: [
            {
              headerName: '',
              field: '',
              width: 40,
              headerCheckboxSelection: true,
              checkboxSelection: true,
              sortable: false,
              suppressMenu: true,
              suppressSizeToFit: true,
              resizable: false
            },
            {
              headerName: this.$t('CargoMsg.Cargo_PalletID'),
              colId: 'palletNo',
              field: 'palletNo',
              width: 100
            },
            {
              headerName: this.$t('CargoMsg.Cargo_BoxQuantity'),
              colId: 'boxesNumber',
              field: 'boxesNumber',
              width: 100,
              valueFormatter: params => {
                return this.$numeral(params.value).format('0')
              }
            },
            {
              headerName: this.$t('CargoMsg.Cargo_Goods'),
              colId: 'cargoName',
              field: 'cargoName',
              width: 100
            }
            /*,
            {
              headerName: '状态',
              colId: 'status',
              field: 'status',
              width: 100,
              valueFormatter: params => {
                return params.value && Number(params.value) === 1 ? '已出库' : ''
              }
            }*/
          ],
          downLeftRowData: [],
          gridApi: null
        },
        right: {
          gridParams: {},
          gridOptions: {
            rowSelection: 'multiple',
            suppressCellSelection: true,
            suppressRowSelection: false,
            suppressRowClickSelection: false,
            rowMultiSelectWithClick: false,
            context: {
              componentParent: this
            }
          },
          downRightColumnDefs: [
            /* {
              headerName: '序号',
              field: 'sequenceNo',
              colId: 'sequenceNo',
              width: 65
            },*/
            {
              headerName: '货箱编号',
              field: 'containerNo',
              colId: 'containerNo',
              width: 150
            },
            {
              headerName: 'Shipment Id',
              field: 'shipmentId',
              colId: 'shipmentId',
              width: 150
            },
            {
              headerName: '中文品名',
              field: 'cargoChineseName',
              colId: 'cargoChineseName',
              width: 150
            },
            {
              headerName: '商品数量',
              field: 'quantity',
              colId: 'quantity',
              width: 150,
              valueFormatter: params => {
                return this.$numeral(params.value).format('0')
              }
            }
          ],
          downRightRowData: [],
          gridApi: null
        }
      },
      pickerOptionsForDeliveryTime: { // 设置可选时间范围
        disabledDate: this.disabledDeliveryTime
      },
      // 出库
      exWarehouse: {
        visible: false,
        opType: '', // 区分点击的是 按托盘出库【pallet】 还是 按箱出库【box】
        selectedRows: [], // 选中数据
        boxesNumber: 0, // 货箱数量
        palletNumber: 0, // 托盘数量
        deliveryMode: 0, // 出库模式
        warehouseOutDate: '', // 出库日期
        remark: '', // 备注
        operater: 0, // 操作人
        logisticsNo: '', // 物流单号
        preDeliveryTime: '', // 预计送达时间
        deliveryTime: '' // 送达时间
      },
      // 按箱出库
      byBox: {
        visible: false,
        containerNo: '', // 货箱编号
        selectedCount: 0, // 选中
        upQuantity: 0, // 拣选后面的件数
        containerNoOpt: '=', // 货箱编号 操作符
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '',
            field: '',
            width: 40,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          // {
          //   headerName: '序号',
          //   field: 'sequenceNo',
          //   width: 65
          // },
          {
            headerName: '货箱编号',
            field: 'containerNo',
            width: 150
          },
          {
            headerName: 'Shipment Id',
            field: 'shipmentId',
            width: 150
          },
          {
            headerName: '中文品名',
            field: 'cargoChineseName',
            width: 150
          },
          {
            headerName: '货物箱重量',
            field: 'singleBoxWeight',
            width: 150
          },
          {
            headerName: '货物箱长度cm',
            field: 'boxLength',
            width: 150
          },
          {
            headerName: '货物箱宽度cm',
            field: 'boxWidth',
            width: 150
          },
          {
            headerName: '货物箱高度cm',
            field: 'boxHeight',
            width: 150
          },
          {
            headerName: '商品数量',
            field: 'quantity',
            width: 150
          }
        ],
        gridApi: null
      },
      upRowData: [], // 库存信息
      outWarehouseCount: 0, // 已出库
      noOutWarehouseCount: 0, // 未出库
      job: {}, // 业务
      // 出库备注
      issueRemarks: {
        visible: false,
        remark: '', // 备注
        keys: [], // uuids
        type: '', // 弹框标题
        deliveryTime: '',
        state: 1 // 1显示备注 2显示日期

      },
      storageAgeEdit: {
        visible: false,
        storageAgeDayEst: 0,
        storageAgeWeekEst: 0,
        storageAgeDay: 0,
        storageAgeWeek: 0,
        params: {}
      },
      // 批次日志
      batchLog: {
        visible: false,
        warehouseInUuid: [], // uuids
        gridOptions: {

        },
        columnDefs: [
          {
            headerName: '时间',
            field: 'dateModified',
            flex: 1
          },
          {
            headerName: '操作人',
            field: 'operaterId',
            flex: 1,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: '操作类型',
            field: 'operateName',
            flex: 1
          }
        ],
        rowData: []
      }
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEditing
    },
    upSelectedRow() {
      return this.form.warehouseInDetailList[this.up.goodGridOptions.selectedRowIndex]
    },
    downSelectedRow() {
      return this.form.fbaOutWarehouses[this.down.goodGridOptions.selectedRowIndex]
    },
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    fbaLob() {
      return this.source === 'fbaSea' || this.source === 'fbaAir'
    },
    isNoInWarehouse() { // 未入库
      return !this.form.outWarehouseStatus || Number(this.form.outWarehouseStatus) === 0
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      if (this.fbaLob) { // 根据业务货物国外仓数据
        this.getOverseaWarehouse(row)
      } else {
        this.form = row // row 是入库单
        this.initOverseaWarehouse()
      }
    },
    // 根据业务加载国外仓信息
    getOverseaWarehouse(row) {
      const params = {}
      params.jobUuid = row.uuid
      params.oversea = true
      loadWarehouseInRelated(params).then(res => {
        const warehouseIn = new WarehouseIn().fillDefaultValue().getData()
        const items = res.data
        if (items.warehouseIn) { //
          for (const key in items.warehouseIn) {
            if (typeof warehouseIn[key] === 'object') {
              continue
            }
            warehouseIn[key] = items.warehouseIn[key]
          }
        }
        for (const key in items) {
          if (key === 'warehouseIn') {
            continue
          }
          warehouseIn[key] = items[key] || null
        }
        this.form = warehouseIn
        this.initOverseaWarehouse()
      })
    },
    // 初始化国外仓相关数据
    initOverseaWarehouse() {
      const allDetailList = this.form.warehouseInDetailList || []
      const shipments = []
      const shipmentIds = []
      // 将货箱明细根据shipmentId+中文品名进行分组
      const map = new Map()
      for (const detail of allDetailList) {
        const key = detail.shipmentId + '-' + detail.cargoChineseName
        if (!key) continue
        let tempArr = null
        if (map.has(key)) {
          tempArr = map.get(key)
        }
        if (!tempArr) {
          tempArr = []
        }
        tempArr.push(detail)
        map.set(key, tempArr)

        // 相同的shipmentId只取一条数据
        if (!shipmentIds.includes(key)) {
          shipmentIds.push(key)
          shipments.push(detail)
        }
      }
      for (const shipment of shipments) {
        shipment.allBoxesNumber = 0 // 箱数
        shipment.dtBoxesNumber = 0 // 已打托箱数
        shipment.szBoxesNumber = 0 // 散装箱数
        shipment.syBoxesNumber = 0 // 在库剩余箱数

        const key = shipment.shipmentId + '-' + shipment.cargoChineseName
        const detailList = map.get(key)
        if (detailList) {
          for (const curDetail of detailList) {
            shipment.allBoxesNumber += curDetail.boxesNumber
            if (curDetail.palletUuid && curDetail.palletUuid.trim()) {
              shipment.dtBoxesNumber += curDetail.boxesNumber
            }
            if (!curDetail.palletUuid || !curDetail.palletUuid.trim()) {
              shipment.szBoxesNumber += curDetail.boxesNumber
            }
            if (!curDetail.outWarehouseUuid || !curDetail.outWarehouseUuid.trim()) {
              shipment.syBoxesNumber += curDetail.boxesNumber
            }
          }
        }
      }
      this.upRowData = shipments

      // 托盘
      let outWarehouseCount = 0
      let noOutWarehouseCount = 0
      const allPallets = this.form.fbaPallets || []
      for (const curPallet of allPallets) {
        // status = 1 已出库
        if (curPallet.status && Number(curPallet.status) === 1) {
          outWarehouseCount += 1
        } else {
          noOutWarehouseCount += 1
        }
      }
      this.outWarehouseCount = outWarehouseCount || 0
      this.noOutWarehouseCount = noOutWarehouseCount || 0
    },
    // 按托盘出库
    byPalletHandler() {
      const allDetailList = this.form.warehouseInDetailList || []
      const allPallets = this.form.fbaPallets || []

      // 将托盘和已打托的箱货信息组装好
      const downLeftRowData = []
      for (const pallet of allPallets) {
        if (pallet.status && Number(pallet.status) === 1) { // 如果已出库的话就过滤掉
          continue
        }
        pallet.warehouseInDetailList = []
        if (allDetailList.length <= 0) continue
        for (const detail of allDetailList) {
          if (detail.palletUuid === pallet.uuid) {
            pallet.warehouseInDetailList.push(detail)
          }
        }
        // 没有明细的托盘，不可以出库
        if (pallet.warehouseInDetailList.length <= 0) {
          continue
        }
        downLeftRowData.push(pallet)
      }
      if (downLeftRowData.length <= 0) {
        this.$message.warning('没有托盘数据可以出库')
        return
      }
      this.byPallet.left.downLeftRowData = downLeftRowData
      this.byPallet.visible = true
    },
    // 根据中文名查询托盘
    searchPallet() {
      if (!this.byPallet.left.downLeftRowData || this.byPallet.left.downLeftRowData.length <= 0) {
        this.$message.warning('没有可以查询的数据。')
        return
      }
      // 操作符
      const cargoNameOpt = 'LIKE'
      // 条件
      const cargoChineseName = (this.byPallet.left.cargoName && this.byPallet.left.cargoName.trim()) ? this.byPallet.left.cargoName.trim() : ''
      const fhConditions = [] // 满足条件的集合
      for (const curRow of this.byPallet.left.downLeftRowData) {
        if (cargoChineseName && cargoNameOpt === 'LIKE') { // 包含
          if (curRow.cargoName.indexOf(cargoChineseName) === -1) {
            continue
          }
        }
        fhConditions.push(curRow)
      }
      this.byPallet.left.gridApi.setRowData(fhConditions)
      this.byPallet.left.gridApi.clearFocusedCell()
      this.byPallet.left.gridApi.refreshCells({ force: true })
      this.byPallet.right.downRightRowData = []
    },
    // 改变托盘，右边明细跟着变
    palletChangeHandler(event) {
      const selectedPallet = event.data
      this.byPallet.right.downRightRowData = selectedPallet.warehouseInDetailList || []
      this.byPallet.right.gridApi.clearFocusedCell()
      this.byPallet.right.gridApi.refreshCells({ force: true })
    },
    // 选择好托盘
    chooseByPallet() {
      const selectedPallets = this.byPallet.left.gridApi.getSelectedRows()
      if (!selectedPallets || selectedPallets.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      this.exWarehouse.opType = 'pallet'
      // 默认值
      this.exWarehouse.palletNumber = selectedPallets.length
      this.exWarehouse.deliveryMode = 1
      this.exWarehouse.operater = this.$store.getters.userId
      // 初始化
      this.exWarehouse.warehouseOutDate = ''
      this.exWarehouse.remark = ''
      this.exWarehouse.logisticsNo = ''
      this.exWarehouse.preDeliveryTime = ''
      this.exWarehouse.deliveryTime = ''

      this.exWarehouse.selectedRows = selectedPallets
      this.exWarehouse.visible = true
    },
    // 确认按托盘出库
    toByPallet() {
      const selectedPallets = this.exWarehouse.selectedRows
      if (!selectedPallets || selectedPallets.length <= 0) {
        this.$message.warning('未选择托盘')
        return
      }
      if (!this.exWarehouse.palletNumber || Number(this.exWarehouse.palletNumber) <= 0) {
        this.$message.warning('托盘数量不能为空')
        return
      }
      const fbaOutWarehouse = {}
      fbaOutWarehouse.keys = Array.from(selectedPallets, p => p.uuid)
      this.saveToOut(fbaOutWarehouse)
    },
    // 按箱出库
    byBoxHandler() {
      const allDetailList = this.form.warehouseInDetailList || []
      const boxRowData = []
      for (const detail of allDetailList) {
        if (detail.outWarehouseUuid) { // 已出库的箱子无需再显示
          continue
        }
        if (detail.palletUuid || detail.palletNo) { // 按箱出库只能是选未打托的箱
          continue
        }
        boxRowData.push(detail)
      }
      if (boxRowData.length <= 0) {
        this.$message.warning('没有货箱数据可以出库')
        return
      }
      this.byBox.rowData = boxRowData
      this.byBox.visible = true
    },
    // 选择好货箱
    chooseByBox() {
      const selectedRows = this.byBox.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      this.exWarehouse.opType = 'box'
      // 默认值
      this.exWarehouse.boxesNumber = selectedRows.length
      this.exWarehouse.deliveryMode = 2
      this.exWarehouse.operater = this.$store.getters.userId
      // 初始化
      this.exWarehouse.palletNumber = 0
      this.exWarehouse.warehouseOutDate = ''
      this.exWarehouse.remark = ''
      this.exWarehouse.logisticsNo = ''
      this.exWarehouse.preDeliveryTime = ''
      this.exWarehouse.deliveryTime = ''

      this.exWarehouse.selectedRows = selectedRows
      this.exWarehouse.visible = true
    },
    // 查询未出库的货箱
    byBoxSearchNoOut() {
      if (!this.byBox.rowData || this.byBox.rowData.length <= 0) {
        this.$message.warning('没有可以查询的数据。')
        return
      }
      // 操作符
      const containerNoOpt = this.byBox.containerNoOpt
      // 条件
      const containerNo = (this.byBox.containerNo && this.byBox.containerNo.trim()) ? this.byBox.containerNo.trim() : ''

      const fhConditions = [] // 满足条件的集合
      for (const curRow of this.byBox.rowData) {
        if (containerNo) {
          if (containerNoOpt === '=') { // 等于
            if (curRow.containerNo !== containerNo) {
              continue
            }
          } else if (containerNoOpt === '!=') { // 不等于
            if (curRow.containerNo === containerNo) {
              continue
            }
          } else if (containerNoOpt === 'LIKE') { // 包含
            if (curRow.containerNo.indexOf(containerNo) === -1) {
              continue
            }
          }
        }
        fhConditions.push(curRow)
      }
      this.byBox.gridApi.setRowData(fhConditions)
      this.byBox.gridApi.clearFocusedCell()
      this.byBox.gridApi.refreshCells({ force: true })
    },
    // 拣选
    byBoxPick() {
      if (!this.byBox.rowData || this.byBox.rowData.length <= 0) {
        this.$message.warning('没有可以拣选的货物。')
        return
      }
      if (!this.byBox.upQuantity || this.byBox.upQuantity <= 0) {
        this.$message.warning('请输入拣选件数。')
        return
      }
      const nodes = this.byBox.gridOptions.api.getRenderedNodes()
      let index = 0
      for (const item of nodes) {
        index++
        item.setSelected(true)
        if (index > this.byBox.upQuantity) {
          item.setSelected(false)
        }
      }
    },
    // 确认按箱出库
    toByBox() {
      const selectedRows = this.exWarehouse.selectedRows
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      if (!this.exWarehouse.boxesNumber || Number(this.exWarehouse.boxesNumber) <= 0) {
        this.$message.warning('货箱数量不能为空')
        return
      }
      if (this.exWarehouse.deliveryMode === 1) {
        if (!this.exWarehouse.palletNumber || Number(this.exWarehouse.palletNumber) <= 0) {
          this.$message.warning('托盘数量不能为空')
          return
        }
        if (Number(this.exWarehouse.palletNumber) > Number(this.exWarehouse.boxesNumber)) {
          this.$message.warning('托盘数量不能大于货箱数量')
          return
        }
      }
      const fbaOutWarehouse = {}
      fbaOutWarehouse.boxesNumber = this.exWarehouse.boxesNumber
      fbaOutWarehouse.keys = Array.from(selectedRows, p => p.uuid)
      this.saveToOut(fbaOutWarehouse)
    },
    // 出库保存公共
    saveToOut(fbaOutWarehouse) {
      if (!this.exWarehouse.warehouseOutDate) {
        this.$message.warning('出库时间不能为空')
        return
      }
      if (this.form.warehouseInDate) {
        const warehouseOutDate = moment(this.exWarehouse.warehouseOutDate).format('YYYY-MM-DD HH:mm:ss')
        const warehouseInDate = moment(this.form.warehouseInDate).format('YYYY-MM-DD HH:mm:ss')
        if (warehouseInDate > warehouseOutDate) {
          this.$message.warning('出库时间不能早于入库时间，请检查')
          return
        }
      }

      fbaOutWarehouse.palletNumber = this.exWarehouse.palletNumber
      fbaOutWarehouse.deliveryMode = this.exWarehouse.deliveryMode
      fbaOutWarehouse.operater = this.exWarehouse.operater
      fbaOutWarehouse.warehouseOutDate = this.exWarehouse.warehouseOutDate
      fbaOutWarehouse.remark = this.exWarehouse.remark
      fbaOutWarehouse.logisticsNo = this.exWarehouse.logisticsNo
      fbaOutWarehouse.preDeliveryTime = this.exWarehouse.preDeliveryTime
      fbaOutWarehouse.deliveryTime = this.exWarehouse.deliveryTime
      fbaOutWarehouse.warehouseInDate = this.form.warehouseInDate
      fbaOutWarehouse.warehouse = this.form.warehouse
      const storageAgeEst = FbaWarehouseInUtil.calStorageAgeEst(fbaOutWarehouse)
      fbaOutWarehouse.storageAgeDay = storageAgeEst.storageAgeDayEst
      fbaOutWarehouse.storageAgeWeek = storageAgeEst.storageAgeWeekEst
      const len = this.form.fbaOutWarehouses.length
      // 序号
      fbaOutWarehouse.sequenceNo = len + 1
      // 批次号
      fbaOutWarehouse.batchNo = this.form.jobNo + '-' + (len > 9 ? (len + 1) : '0' + (len + 1))
      fbaOutWarehouse.warehouseInUuid = this.form.uuid

      let saveMethod = saveToByPallet // 按托盘出库
      if (this.exWarehouse.opType === 'box') { // 按箱出库
        saveMethod = saveToByBox
      }
      this.loading = getLoading()
      saveMethod(fbaOutWarehouse).then(res => {
        if (res.data > 0) {
          this.$message.success('出库' + this.$t('Message.Success'))
          this.$emit('success', true)
        }
      }).finally(() => {
        if (this.exWarehouse.opType === 'box') { // 按箱出库
          this.byBox.visible = false
        } else {
          this.byPallet.visible = false
        }
        this.exWarehouse.visible = false
        this.loading.close()
      })
    },
    // 库龄调整
    kltzHandler() {
      const selectedRows = this.down.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      if (!selectedRows || selectedRows.length > 1) {
        this.$message.warning('只能选中一条数据')
        return
      }
      const obj = {}
      selectedRows[0].warehouse = this.form.warehouse
      const storageAgeEst = FbaWarehouseInUtil.calStorageAgeEst(selectedRows[0])
      obj.keys = Array.from(selectedRows, p => p.uuid)
      obj.warehouseInUuid = this.form.uuid
      this.storageAgeEdit.params = obj
      this.storageAgeEdit.storageAgeDayEst = storageAgeEst.storageAgeDayEst
      this.storageAgeEdit.storageAgeWeekEst = storageAgeEst.storageAgeWeekEst
      this.storageAgeEdit.storageAgeDay = selectedRows.storageAgeDay
      this.storageAgeEdit.storageAgeWeek = selectedRows.storageAgeWeek
      this.storageAgeEdit.visible = true
    },
    storageAgeSaveCallBack() {
      this.loading = getLoading()
      this.storageAgeEdit.params.storageAgeDay = this.storageAgeEdit.storageAgeDay ? this.storageAgeEdit.storageAgeDay : this.storageAgeEdit.storageAgeDayEst
      this.storageAgeEdit.params.storageAgeWeek = this.storageAgeEdit.storageAgeWeek ? this.storageAgeEdit.storageAgeWeek : this.storageAgeEdit.storageAgeWeekEst
      storageAgeAdjustment(this.storageAgeEdit.params).then(res => {
        if (res.data > 0) {
          this.$message.success('库龄调整' + this.$t('Message.Success'))
          this.$emit('success', true)
        }
      }).finally(() => {
        this.loading.close()
      }).catch(() => {
      })
      this.storageAgeEdit.visible = false
    },
    // 修改出库备注
    xgckbzHandler() {
      const selectedRows = this.down.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      if (!selectedRows || selectedRows.length > 1) {
        this.$message.warning('只能选中一条数据')
        return
      }
      const keys = []
      keys.push(selectedRows[0].uuid)
      this.issueRemarks.type = this.$t('Warehouse.updateIssueRemarks')
      this.issueRemarks.keys = keys
      this.issueRemarks.remark = selectedRows[0].remark
      this.issueRemarks.visible = true
      this.issueRemarks.state = 1
    },
    // 撤销出库
    cxckHandler() {
      const selectedRows = this.down.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      for (const selectedRow of selectedRows) {
        if (selectedRow.status && Number(selectedRow.status) === Number(FbaJobConstants.DELIVERY_STATUS_ROLL_BACK.code)) {
          this.$message.warning('请勾选已出库的批次。')
          return
        }
      }
      this.$confirm('确认撤销该条出库记录？', '确认', {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const obj = {}
        obj.keys = Array.from(selectedRows, p => p.uuid)
        obj.warehouseInUuid = this.form.uuid
        this.loading = getLoading()
        rollbackOutWarehouse(obj).then(res => {
          if (res.data > 0) {
            this.$message.success('撤销出库' + this.$t('Message.Success'))
            this.$emit('success', true)
          }
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 日志
    logHandler() {
      const selectedRows = this.down.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      if (!selectedRows || selectedRows.length > 1) {
        this.$message.warning('只能选中一条数据')
        return
      }
      queryOutWarehouseBatchLog({ outWarehouseUuid: selectedRows[0].uuid }).then(res => {
        this.batchLog.rowData = res.data
      })
      this.batchLog.visible = true
    },
    disabledDeliveryTime(time) {
      return time.getTime() > new Date().getTime()
    },
    // 出库保存
    submitIssurRemarks() {
      if (this.issueRemarks.state === 2 && (this.issueRemarks.deliveryTime === null || this.issueRemarks.deliveryTime === '')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterDate'))
        return
      }
      // 如果是出库备注就不传递日期参数
      const param = {}
      param.status = this.issueRemarks.state
      param.keys = this.issueRemarks.keys
      if (this.issueRemarks.type === this.$t('Warehouse.updateIssueRemarks')) {
        param.remark = this.issueRemarks.remark
      } else {
        param.deliveryTime = this.issueRemarks.deliveryTime
      }
      this.loading = getLoading()
      updateIssueRemarks(param).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        this.issueRemarks.visible = false
        this.$emit('success', true)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 修改送达日期
    toUpdServiceDate() {
      const selectedRows = this.down.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length <= 0) {
        this.$message.warning('未选择数据')
        return
      }
      if (!selectedRows || selectedRows.length > 1) {
        this.$message.warning('只能选中一条数据')
        return
      }
      const keys = []
      keys.push(selectedRows[0].uuid)
      this.issueRemarks.type = this.$t('Warehouse.DateOfService')
      this.issueRemarks.keys = keys
      this.issueRemarks.deliveryTime = selectedRows[0].deliveryTime
      this.issueRemarks.visible = true
      this.issueRemarks.state = 2
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // params.WAREHOUSE_UUID = [this.form.uuid]
      // params.USER_ID = this.$store.getters.userId
      PrintTemplateUtil.buildPrintDataByFbaOverseaWarehouse(this.form, params)
      params.category = 'FBA_OVERSEA_WAREHOUSE'
      return params
    }
  }
}
</script>

<style lang="scss">
</style>
